import React, { useState, useEffect } from "react";
import { Trans } from "react-i18next";
import ImageUploadModal from "../ImageUploadModal.component";
import { AttachmentIcon } from "../../../../../assets";
import useAlert from "../../../../../utils/useAlert";
import alertConstant from "../../../../../constant/messages/toaster.json";

//current limit is 3 MB = 3*1048576 = 3145728
const MAX_FILE_UPLOAD_SIZE = 3145728;
function MultiplePhotoUpload({
  currentResponse,
  setCurrentResponse,
  loginDetails,
  uploadImage,
  deleteImage,
  deleteImageLoading,
  uploadImageLoading,
}) {
  let [isOpen, setIsOpen] = useState(false);
  const [uploadedFile, setUploadedFile] = useState([]);
  const [dragText, setDragText] = useState("Drop your file here, or browse");
  const { showAlert } = useAlert();

  useEffect(() => {
    // console.log(currentResponse, '--------upload', uploadImage);
    setUploadedFile(currentResponse.files ? [...currentResponse.files] : []);
  }, [currentResponse]);

  const isFileSizeOffLimit = (files, limitInBytes) => {
    let totalSizeOfFiles = 0;
    for (let i = 0; i < files.length; i++) {
      totalSizeOfFiles += files[i].size;
    }
    return totalSizeOfFiles > limitInBytes;
  };
  const fileUpload = (e) => {
    if (isFileSizeOffLimit(e.target.files, MAX_FILE_UPLOAD_SIZE)) {
      showAlert("error", alertConstant.upload_max_size_limit_crossed, 3000);
      e.target.files = null;
      e.target.value = null;
      return;
    }

    for (let i = 0; i < e.target.files.length; i++) {
      uploadedFile.push(e.target.files[i]);
      setUploadedFile([...uploadedFile]);
    }
    setCurrentResponse({
      ...currentResponse,
      files: [...uploadedFile],
    });
    setTimeout(() => {
      handleSubmit();
    }, 100);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragText("Drop your file here, or browse");
    if (e.dataTransfer.items) {
      // Use DataTransferItemList interface to access the file(s)
      for (let i = 0; i < e.dataTransfer.items.length; i++) {
        // If dropped items aren't files, reject them
        if (e.dataTransfer.items[i].kind === "file") {
          var file = e.dataTransfer.items[i].getAsFile();
          uploadedFile.push(file);
          setUploadedFile(uploadedFile);
        }
      }
    } else {
      // Use DataTransfer interface to access the file(s)
      for (let i = 0; i < e.dataTransfer.files.length; i++) {
        console.log("... file[" + i + "].name = " + e.dataTransfer.files[i].name);
      }
    }
    setTimeout(() => {
      handleSubmit();
    }, 100);
  };

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragText("Drop Here ...");
  };

  const removeFile = (e) => {
    e.preventDefault();
    let id = e.currentTarget.getAttribute("id");
    currentResponse.assetMedia.splice(id, 1);
    setCurrentResponse({ ...currentResponse });
    setUploadedFile(uploadedFile.filter((file, i) => i != id));
  };

  const handleSubmit = async () => {
    //console.log(uploadedFile, '------>>>>>><<<<<<<<<<');
    let mediaData = new FormData();
    uploadedFile?.map((data) => {
      mediaData.append("media", data);
    });
    uploadImage(uploadedFile, (mediaFiles) => {
      callbackAfterUpload(mediaFiles);
    });
  };

  const callbackAfterUpload = (currentMediaFiles) => {
    let mediaFiles = [];
    if (currentResponse.responseMedia) {
      mediaFiles = [...currentResponse.responseMedia, ...currentMediaFiles];
    } else {
      mediaFiles = [...currentMediaFiles];
    }
    setCurrentResponse({
      ...currentResponse,
      files: [...uploadedFile],
      responseMedia: [...mediaFiles],
    });
  };

  const deleteFile = (fileName) => {
    // console.log(uploadedFile, '------>>>>>><<<<<<<<<<');
    deleteImage(fileName, (fileName) => {
      callbackAfterDelete(fileName);
    });
  };

  const callbackAfterDelete = (fileName) => {
    let mediaFiles = [];
    //console.log(currentResponse.responseMedia, '************&&&&&*******');
    var imageList = [...currentResponse.responseMedia];
    var index = imageList.indexOf(fileName);
    imageList.splice(index, 1);

    uploadedFile.splice(index, 1);
    setCurrentResponse({
      ...currentResponse,
      files: [...uploadedFile],
      responseMedia: [...imageList],
    });
  };

  function openModal() {
    setIsOpen(true);
  }

  return (
    <div className="flex items-center justify-center rounded-md image-upload-style">
      <ImageUploadModal
        responseMedia={currentResponse?.responseMedia}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        fileUpload={fileUpload}
        deleteImageLoading={deleteImageLoading}
        uploadImageLoading={uploadImageLoading}
        uploadedFile={uploadedFile}
        deleteFile={deleteFile}
      />
      <div lg={5} className="absolute bottom-0">
        <div
          border="primary"
          className="border-gray-300 text-center"
          onDrop={handleDrop}
          onDragLeave={() => setDragText("Drop your file here, or browse")}
          onDragOver={handleDrag}
        >
          <span className="custom-file">
            {uploadedFile?.length < 1 && (
              <label
                className="flex items-center justify-center border-[#919191] border p-2 rounded-sm"
                style={{ cursor: "pointer" }}
              >
                <input
                  onChange={fileUpload}
                  type="file"
                  className="hidden"
                  name="uploadFile"
                  multiple
                  accept="image/png, image/jpeg,application/pdf"
                />
                <AttachmentIcon className="upload-icon-color w-7" />
              </label>
            )}
          </span>
          {/* <span className="h6 font-weight-bolder mb-0">{t(dragText)}</span> */}
          {uploadedFile?.length < 1 && (
            <span className="font-kanit mt-2 d-block" style={{ fontSize: "12px", color: "#919191" }}>
              <Trans>MEDIA</Trans>
            </span>
          )}
          {uploadedFile?.length > 0 && (
            <div className="border-[#919191] border p-2 rounded-md relative">
              <>
                <div className="loader-cls">
                  {uploadImageLoading && (
                    <svg
                      role="status"
                      className="inline ml-2 w-5 h-5 text-gray-200 animate-spin dark:text-gray-600"
                      viewBox="0 0 100 101"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                        fill="currentColor"
                      />
                      <path
                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                        fill="#1C64F2"
                      />
                    </svg>
                  )}
                  <img
                    className="w-28 h-28 object-cover rounded-md"
                    src={URL.createObjectURL(uploadedFile[uploadedFile?.length - 1])}
                    alt="uploaded file"
                  />
                </div>
              </>

              <div onClick={openModal} className="text-color-blackDark text-xs cursor-pointer font-sans">
                {uploadedFile?.length} <Trans>Image Uploaded</Trans>
                <div className="w-full">
                  <AttachmentIcon className="upload-icon-color h-7 inline mt-2.5" />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default MultiplePhotoUpload;
